var swatches_wishlist = JSON.parse(localStorage.getItem('sw-wishlist')) || [];
var swatchesMasonrySettings = {
	columnWidth: '.vt-swatch',
	itemSelector: '.vt-swatch',
	percentPosition: true
};
var inspirationMasonrySettings = {
	columnWidth: '.vt-inspiration-item',
	itemSelector: '.vt-inspiration-item',
	percentPosition: true
};
//var $swatchesGrid = $('.vt-swatches:first').masonry(swatchesMasonrySettings);
var $inspirationGrid = $('.vt-inspirations').length ? $('.vt-inspirations').masonry(inspirationMasonrySettings) : $('.vt-inspirations');
var filtersTop = $('.vt-swatches-filters').offset().top;
var filters_namespace = '.collection-' + SWATCHES_SECTION_ID;

displayWishlist();

AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }
  
    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, updateURLHash = true) {
  
        const sectionRenders = this.sections.map(section => {
  
          let url = basePath;
		  
		  if(basePath.indexOf('?') > -1){
			url += `&section_id=${section.sectionId}`;
		  }else{
			url += `?section_id=${section.sectionId}`;
		  }
          const cachedSectionUrl = cachedSection => cachedSection.url === url;
  
          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });
  
        //if (updateURLHash) this.updateURLHash(updatedParams);
		if (updateURLHash) this.updateURLHash(basePath);
  
        return Promise.all(sectionRenders);
      },
  
      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);
  
        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },
  
      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
  
        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },
  
      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );
  
        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }
  
            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }
  
        return section;
      },
  
      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
  
        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          };
        }
  
        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }
  
        return clone;
      },
  
      updateURLHash: function (searchParams) {
        // history.pushState(
        //   {},
        //   '',
        //   `${window.location.pathname}${
        //     searchParams && '?'.concat(searchParams)
        //   }`,
        // );
		history.pushState(
          {},
          '',
          searchParams,
        );
      },
  
      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });
  
    return AjaxRenderer;
})();
  
ajaxRenderer = new AjaxRenderer({
	sections: [
		{
		sectionId: SWATCHES_SECTION_ID,
		nodeId: 'CollectionAjaxContent',
		},
	],
	//onReplace: this.onReplaceAjaxContent.bind(this),
}); 

window.on = function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
};
window.off = function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
20};
window.off('popstate' + filters_namespace);
window.on('popstate' + filters_namespace, function(state) {
	if (state) {
	const newUrl = window.location.href;
	ajaxRenderer.renderPage(newUrl).then(() => {});
	}
}.bind(this));
  
$(document).ready(function(){     
}).on('FILTERS_APPLIED', function(){
	//$swatchesGrid.masonry('destroy').masonry(swatchesMasonrySettings);
	if($inspirationGrid.length){
		$inspirationGrid.masonry('destroy').masonry(inspirationMasonrySettings);
	}
	
	//$('.vt-swatches-filters').toggleClass('open')
}).on('click', '.vt-swatch .product-preview', function(){
	
	$(this).closest('.vt-swatch').find('.product-image-preview').toggle();

}).on('click', '[data-atw]', function(e){
		
	var item = $(this).data('atw'),
		idx = _.indexOf(swatches_wishlist, item)
	
	if(idx > -1){
		swatches_wishlist.splice(idx, 1);
	}else{
		swatches_wishlist.push(item);
	}      	
	
	localStorage.setItem('sw-wishlist', JSON.stringify(swatches_wishlist))
	displayWishlist();

}).on('click', '.vt-swatches-filters-open', function(){
	
	$(this).closest('.vt-swatches-filters').toggleClass('open')
	
}).on('click', '.vt-swatches-filters-apply, .vt-swatches-filters-groups', function(e){
	if(!$(e.target).is('.vt-filter-link-container') && !$(e.target).closest('.vt-filter-link-container').length && !$(e.target).closest('.vt-swatches-filters-groups').length){
	  $(this).closest('.vt-swatches-filters').toggleClass('open')
	}
	
}).on('click', '.vt-swatches-filters-clear', function(){
	
	filterPage({
		link : COLLECTION_URL
	});
	$('.vt-swatches-filters').removeClass('open')
	
}).on('click', '.vt-swatches-filters-wishlist-toggle', function(){
			
	var isWishListFiltered = $(this).hasClass('btn-dark')
	$(this).toggleClass('btn-dark btn-light').find('span').toggle();
	
	$(this).closest('.vt-swatches-filters').removeClass('open');
	$('.vt-swatches .vt-swatch').each(function(){
		
		if(isWishListFiltered){
		$(this).parent().show();
		}else{
		
			var isInWishList = $(this).hasClass('in-whish');
			$(this).parent().toggle(isInWishList);          
		
		}
		
	})
	
}).on('click', '[data-filter-link]', function(e){
	e.preventDefault();
	var link = $(this).attr('href');
	var keepOpen = $(this).data('filter-link')

	ajaxRenderer.renderPage(link).then(() => {
		if(keepOpen){
			$('.vt-swatches-filters').toggleClass('open')
		}
	});
}).on('click', '[data-remove-link]', function(e){
	e.preventDefault();
	var id = $(this).data('remove-link');
	var $this = $(this);

	if(id){
		$this.loading()

		jQuery.post('/cart/change.js', {
			quantity: 0,
			id: id
		}, function(cart){

			$this.stopLoading()

			//$this.text('Add').removeClass('added').attr('data-atc',id)
			$this.hide().siblings().show()

		}, "json");
	}
});


$(window).scroll(function(e){
	
	var scrolledTop = $(this).scrollTop() + $('body').data('top');
	
	if(scrolledTop >= filtersTop){
		$('.vt-swatches-filters').addClass('fixed').css('top', $('body').data('top'))
	}else{
		$('.vt-swatches-filters').removeClass('fixed').css('top', 0)
	}
}).on('load', function(){
	initFilters()
	if($inspirationGrid.length){
		$inspirationGrid.masonry('destroy').masonry(inspirationMasonrySettings);
	}
})


function displayWishlist(){
	var swatches_wishlist = JSON.parse(localStorage.getItem('sw-wishlist')) || [];
	$('.vt-swatches-wishlist .vt-swatches').empty();
	$('.vt-swatch').removeClass('in-whish')
	_.each(swatches_wishlist, function(item){
		var $swatch = $('[data-product="'+ item +'"]').last();
		var swatch = $swatch.addClass('in-whish').clone().removeClass('is-expanded').css('position','static').append('<input type="hidden" name="updates['+ $swatch.data('variant') +']"/>');
		$('.vt-swatches-wishlist .vt-swatches').append(swatch);
	});
	
	if(swatches_wishlist.length){
	$('.vt-swatches-filters-wishlist').removeClass('d-none', swatches_wishlist.length)
	}else{
	$('.vt-swatches-filters-wishlist').addClass('d-none', swatches_wishlist.length)
	}	
			
}